// 职业微视
import React from 'react'

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';


class CareerVideo extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            sourcePath: Config.getSourcePath(),
        }
    }

    notify = ( item ) => {

        if( this.props.notify )
        {
            this.props.notify(item);
        }
    }   

    render()
    {
        const { data, total } = this.props;

        const { sourcePath } = this.state; 

        return ( 
            <div className='sf-career-video-card' >
            {
                data.map((item, index) => {
                    return (
                        <div className='sf-career-video-card-item' key={index + item.key} onClick={ () => {this.notify(item)} }>
                            <div className='sf-career-video-card-icon'> <img src={require('./../../img/' + sourcePath + '/career/' + item.img)}></img></div>
                            <div className='sf-career-video-card-info'> 
                                <div><img src={require('./../../img/' + sourcePath + '/component/praise.png')}></img><span>{item.praise}</span></div>
                                <div><span>{item.time}</span></div>
                            </div>
                            <div className='sf-career-video-card-title'>{ item.title}</div>
                        </div>
                    )
                })
            }
            {
                total > data.length ? 
                <div className='sf-career-video-more'>
                    <span>查看更多</span>
                </div>
                :
                <>
                </>
            }
            </div>
        )
    }
}

export default CareerVideo